<template>
    <div>
        <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                  @change="getListData()">
            <van-tab v-for="item in list" :key="item.type" :title="item.title">
                <van-list v-if="item.list.length > 0" v-model="item.loading" :finished="item.finished"
                          finished-text="没有更多了" @load="getListData">
                    <div v-for="(subItem,index) in item.list" :key="index" class="card" @click="detail(subItem)">
                        <div v-if="subItem.states === '0'">
                            <div style="margin: 15px 0 10px 10px; color: #4E4E4E; font-size: 18px;">{{subItem.userName}}</div>
                            <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">注册时间： {{subItem.registerTime|dateFormat('YYYY-MM-DD')}}</div>
                        </div>
                        <div v-else>
                            <div style="margin: 15px 0 10px 10px; color: #4E4E4E; font-size: 18px;">{{subItem.userName}}</div>
                            <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'被保人数：' + subItem.num}}</div>
                            <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">保险期限： {{subItem.effectiveDate|dateFormat('YYYY-MM-DD')}}~{{subItem.deadline|dateFormat('YYYY-MM-DD')}}</div>
                            <div class="label">查看详情</div>
                        </div>
                        <div style="display: flex; align-items: center;">
                            <span style="color: #066BEE; font-size: 14px;">{{item.title}}</span>
                            <van-icon name="arrow" color="#066BEE" style="margin-right: 5px;"></van-icon>
                        </div>
                    </div>
                </van-list>
                <div v-else
                     style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
                    <span style="margin-top: 20px; color: #999999; font-size: 14px;">暂无客户</span>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>


    import Vue from 'vue';
    import {Tab, Tabs, List, Cell, Icon, Image} from 'vant';

    Vue.use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image);

    export default {
        name: "MyClient",
        data() {
            return {
                active: 0,
                pageSize: 10,
                list: [
                    {title: '未参保', type: '0', list: [], page: 0, loading: false, finished: false},
                    {title: '待支付', type: '1', list: [], page: 0, loading: false, finished: false},
                    {title: '待生效', type: '2', list: [], page: 0, loading: false, finished: false},
                    {title: '参保中', type: '3', list: [], page: 0, loading: false, finished: false},
                    {title: '已失效', type: '4', list: [], page: 0, loading: false, finished: false},
                ],
            }
        },
        created() {
            this.getListData()
        },
        methods: {
            getListData() {
                const item = this.list[this.active]
                if(item.finished){
                    return;
                }
                item.page++
                item.loading = true
                this.$axios.get("/customer/list", {params: {type: item.type, page: item.page, pageSize: this.pageSize}}).then(res => {
                    item.loading = false
                    const datas = res.data.rows;
                    item.list = item.list.concat(datas);
                    if (datas.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    item.loading = false
                })
            },
            detail(item) {
                if (item.insureNum) {
                    this.$axios.get("/jump/insureUrl", {params: {insureNum: item.insureNum}}).then(res => {
                        window.location.href = res.data
                    });
                }else{
                    this.$router.push({path:'/clientDetail', query:{id: item.shareUserId}})
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        display: flex; justify-content: space-between; align-items: center; padding: 10px 0; margin: 10px; background-color: white;
        box-shadow:0px 2px 4px 0px rgba(231,231,231,0.5);
        border-radius:4px;
    }

    .label {
        width:78px;
        height:24px;
        line-height: 24px;
        background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);
        border-radius:0px 12px 12px 0px;
        color: white;
        font-size: 14px;
        text-align: center;
        position: relative;
        right: 2px;
    }

    .label:before {
        content: '';
        background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);
        width: 2px;
        height: 2px;
        position: relative;
        bottom: 2px;
        display: block;
    }
</style>
